<template>
    <div class="box">
        <div class="boxCard">
            <div class="boxCardTitle" style="height: 5%;min-height: 20px;">超270天库存</div>
            <div v-if="userAddress === '仓储部' || userAddress === '七星河路供应链' || userAddress === '运营部' " >
                <vxe-table id="overdueBondedStockTable"  size="mini" ref="overdueBondedStockTable" :data="overdueBondedStockList" border stripe
                header-align="center" :column-config="{resizable: true,sortable: true,drag:true}" max-height="95%" min-height="100px" >
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="createDate" title="入库日期" width="110" sortable ></vxe-column>
                <vxe-column field="blNo" title="提单号" sortable ></vxe-column>
                <vxe-column field="goodsName" title="货物名称"   sortable ></vxe-column>
                <vxe-column field="ownerName" title="货主单位"   sortable ></vxe-column>
            </vxe-table>
            </div>
        </div>
        <div class="boxCard">
           <vc-calendar borderless />
        </div>
        <div class="boxCard">
            3
        </div>
        <div class="boxCard">
            <div class="boxCardTitle">时间线</div>
            <div class="boxCardContent">
                <el-timeline >
                    <el-timeline-item  v-for="item in activities" :key="item.id" :timestamp="item.releaseDate">
                        {{item.title}}
                    </el-timeline-item>
                </el-timeline>
            </div>
        </div>
      
    </div>
</template>
<script>

export default {
    //组件创建
    created() {
    },
    mounted() {
        // 获取当前用户地址
        this.userAddress = localStorage.getItem('address')
        this.getHistoryList();
        if(this.userAddress === '仓储部' || this.userAddress === '七星河路供应链' || this.userAddress === '运营部'){
            this.wmsGetOverdueBondedStock()
        }
    },
    data() {
        return {
            calendarValue: new Date(),
            activities:[], // 时间线数据
            userAddress: '', // 用户地址
            overdueBondedStockList: []
        }
    },
    methods: {
        getHistoryList(){
            this.$api.getHistoryList().then(res => {
                this.activities = res
            })
        },
        wmsGetOverdueBondedStock(){
            this.$api.wmsGetOverdueBondedStock().then(res => {
                this.overdueBondedStockList = res
            })

        }
    }   
}
</script>
<style lang="less" scoped>
.box{
    width: 100%;
    height: calc(100vh - 88px);
    display: grid;
    grid-template-columns: 69fr 29fr;
    grid-template-rows: 50fr  50fr;
    gap: 20px;
    box-sizing: border-box;
    padding: 5px 20px; /* 左右统一边框宽度 */
}
.boxCard{
    // width: 100%;
    // height: 100%;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    border-radius: 8px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    color: #303133;
    transition: .3s;
    padding: 10px;
    display: flex;
    flex-direction: column;
}
.boxCardTitle{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
}
.boxCardContent{
    width: 100%;
    flex: 1;
    overflow-y: auto;

}
</style>